__webpack_require__.p = "/csh-website-chemistry-scholarship/build/";